var bookmarkbubble = require('../../../BookmarkBubble/bookmark_bubble.js')

/**
 * Shows a nice little animated bubble informng the user that they can save
 * the mobile app to their device's home screen by tapping the action
 * toolbar icon and tapping "Add to Home Screen".
 * @constructor
 */
Foundation.View.Mobile.BookmarkBubble = function () {
    var ua = navigator.userAgent;

    // Don't show the bookmark bubble if not running as Safari. In
    // other words, don't show the bubble if we're running in a
    // UIWebView. (This doesn't work for all UIWebViews, as they
    // may set their UA string to contain Safari. But we'll try
    // anyway.)
    if (!ua.match(/\bSafari\b/)) {
        return;
    }

    // Don't show the bookmark bubble if running on Chrome for iOS.
    if (ua.match(/\bCriOS\b/)) {
        return;
    }

    jQuery(window).load(function () {
        (new Foundation.Timer(500)).then(function () {
            var bubble = new bookmarkbubble.Bubble();

            // Ostensibly these functions are for allowing us to track
            // whether a user has seen the bubble and then went on
            // to save to their home screen and use the site as an
            // app, but they're just way more trouble than they're
            // worth. What's really annoying is that we have to set
            // them, or the bubble doesn't work at all.
            bubble.hasHashParameter = function () { return false; };
            bubble.setHashParameter = function () {};

            // We don't seem to be using precomposed icons.
            bubble.REL_ICON_ = "apple-touch-icon";

            // Only make the user dismiss it once.
            bubble.NUMBER_OF_TIMES_TO_DISMISS = 1;

            bubble.showIfAllowedWhenLoaded();
        });
    });
};

// ---------------------------------------------------------------------

window["Foundation"]["View"]["Mobile"]["BookmarkBubble"] = Foundation.View.Mobile.BookmarkBubble;
